function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M63.36 25.7398V36.4318H59.796C52.668 36.4318 56.232 32.8678 45.54 32.8678V22.1758C56.232 22.1758 52.668 25.7398 59.796 25.7398H63.36Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M81.18 55.4401V43.5601H17.82V55.4401M1.97998 97.0201H97.02V55.4401H77.418H1.97998V97.0201Z",
  stroke: "black",
  strokeWidth: 3.96,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.88 63.3601H17.82V73.2601H11.88V63.3601ZM25.74 63.3601H31.68V73.2601H25.74V63.3601ZM39.6 63.3601H45.54V73.2601H39.6V63.3601ZM53.46 63.3601H59.4V73.2601H53.46V63.3601ZM67.32 63.3601H73.26V73.2601H67.32V63.3601ZM81.18 63.3601H87.12V73.2601H81.18V63.3601ZM11.88 79.2001H17.82V89.1001H11.88V79.2001ZM25.74 79.2001H31.68V89.1001H25.74V79.2001ZM39.6 79.2001H45.54V89.1001H39.6V79.2001ZM53.46 79.2001H59.4V89.1001H53.46V79.2001ZM67.32 79.2001H73.26V89.1001H67.32V79.2001ZM81.18 79.2001H87.12V89.1001H81.18V79.2001Z",
  fill: "black"
});

function SvgEmbassy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbassy);
export default __webpack_public_path__ + "static/media/embassy.5fdae722.svg";
export { ForwardRef as ReactComponent };